import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/react-hooks";
import { Button } from "@mui/material";
import { MY_HR_RESET_2FA } from "my-hr/graphql";
import { useMyHrUserByEmployee } from "my-hr/hooks";
import { useOcCurrentUserState } from "oc/hooks";

interface MyHrLoginTwoFactorRegisterCancelProps {
  onCancel: () => void;
  emailAddress: string;
}

export const MyHrLoginTwoFactorRegisterCancel = ({
  onCancel,
  emailAddress,
}: MyHrLoginTwoFactorRegisterCancelProps) => {
  const { t } = useTranslation();

  let { employeeCode } = useOcCurrentUserState();
  const { refetch: refetchUserData } = useMyHrUserByEmployee({
    employee: employeeCode,
  });

  const [resetTwoFactorState] = useMutation(MY_HR_RESET_2FA, {
    onCompleted() {
      onCancel();
    },
    onError() {
      console.error("Error resetting two-factor authentication");
    },
  });

  const handleButtonClick = async () => {
    const { data: refreshedData } = await refetchUserData();

    const failedCode = refreshedData?.userByEmployee?.twoFactorFailedCode ?? 0;

    if (failedCode >= 3) {
      onCancel();
    } else {
      resetTwoFactorState({
        variables: {
          email: emailAddress,
        },
      });
    }
  };

  return (
    <Button
      id="cancel"
      onClick={handleButtonClick}
      variant="text"
      color="secondary"
      fullWidth
      sx={{ marginTop: "36px" }}
    >
      {t("OC_CANCEL")}
    </Button>
  );
};

export default MyHrLoginTwoFactorRegisterCancel;
